import { render, staticRenderFns } from "./CatrgoriesHome.vue?vue&type=template&id=5b60b1c8&scoped=true&"
import script from "./CatrgoriesHome.vue?vue&type=script&lang=js&"
export * from "./CatrgoriesHome.vue?vue&type=script&lang=js&"
import style0 from "./CatrgoriesHome.vue?vue&type=style&index=0&id=5b60b1c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60b1c8",
  null
  
)

export default component.exports